package dev.lingvo.shared.screenshots.render

import dev.lingvo.shared.screenshots.doc.Paint
import dev.lingvo.shared.screenshots.doc.Palette
import dev.lingvo.shared.screenshots.geom.Rect
import kotlin.math.PI
import kotlin.math.abs
import kotlin.math.cos
import kotlin.math.min
import kotlin.math.sin

/** Resolves CSS-angle gradients in user space; radius fractions use the box's shorter side. */
fun resolvePaint(paint: Paint, box: Rect, palette: Palette, slotIndex: Int): ResolvedPaint = when (paint) {
    is Paint.Solid -> ResolvedPaint.Solid(resolveColor(paint.color, palette, slotIndex))
    is Paint.Linear -> {
        val radians = paint.angle * PI / 180
        val dx = sin(radians)
        val dy = -cos(radians)
        val half = (box.w * abs(dx) + box.h * abs(dy)) / 2
        val cx = box.x + box.w / 2
        val cy = box.y + box.h / 2
        ResolvedPaint.Linear(cx - dx * half, cy - dy * half, cx + dx * half, cy + dy * half,
            paint.stops.map { it.at to resolveColor(it.color, palette, slotIndex) })
    }
    is Paint.Radial -> ResolvedPaint.Radial(box.x + paint.cx * box.w, box.y + paint.cy * box.h,
        paint.r * min(box.w, box.h), paint.stops.map { it.at to resolveColor(it.color, palette, slotIndex) })
}
